module.exports = __webpack_public_path__ + "assets/4319c6ae67b616a8a9caec8ed23d151b.mp3";